(function () {
  if (
    window.location.pathname !== '/pages/new-listicle' &&
    window.location.pathname !== '/pages/new-listicle/'
  ) {
    return;
  }

  const FORM_SELECTOR = '[data-testid="klaviyo-form-RAGHEH"]';
  const SCROLL_LOCK_CLASS = 'klaviyo-prevent-body-scrolling';

  function unlockScroll() {
    const html = document.documentElement;
    const body = document.body;

    if (!body) return;

    body.classList.remove(SCROLL_LOCK_CLASS);

    body.style.removeProperty('overflow');
    body.style.removeProperty('overflow-y');
    body.style.removeProperty('position');
    body.style.removeProperty('height');
    body.style.removeProperty('max-height');
    body.style.removeProperty('width');
    body.style.removeProperty('touch-action');
    body.style.removeProperty('padding-right');

    html.style.removeProperty('overflow');
    html.style.removeProperty('overflow-y');
    html.style.removeProperty('position');
    html.style.removeProperty('height');
    html.style.removeProperty('max-height');
    html.style.removeProperty('width');
    html.style.removeProperty('touch-action');
    html.style.removeProperty('padding-right');
  }

  function removePopup() {
    const form = document.querySelector(FORM_SELECTOR);

    if (form) {
      const dialog = form.closest('[role="dialog"]');

      if (dialog) {
        dialog.remove();
      } else {
        const popup = form.closest('[data-testid="POPUP"]');

        if (popup) {
          popup.remove();
        } else {
          form.remove();
        }
      }
    }

    document
      .querySelectorAll(
        '[role="dialog"][aria-label="POPUP Form"][data-kl-scroll-locking-modal]'
      )
      .forEach(function (element) {
        element.remove();
      });

    unlockScroll();
  }

  function init() {
    removePopup();

    let attempts = 0;
    const maxAttempts = 30;

    const interval = setInterval(function () {
      attempts++;

      removePopup();

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener(
    'load',
    function () {
      removePopup();
    },
    { once: true }
  );
})();